export default {
  unsaved: {
    title: '¿Guardar los cambios?',
    description: 'Has hecho cambios en este paso que aún no se han guardado.',
    discard: 'Descartar',
    save_and_continue: 'Guardar y continuar',
  },
  title: 'Configura tu restaurante',
  nav: {
    completed: 'Completado',
    locked: 'Gestionado por tu proveedor',
    aria_label: 'Pasos de lanzamiento',
    step_label: 'Paso {{number}}',
    section_label: 'Lanzamiento',
    back_to_home: 'Volver al inicio',
  },
  owner_invite: {
    hint: '¿Prefieres que el propietario del restaurante termine la configuración? Invítale y continuará donde lo dejaste.',
    sent: 'Invitación enviada a {{name}} ({{email}}) el {{date}}.',
  },
  footer: {
    step_of: 'Paso {{current}} de {{total}}',
  },
  buttons: {
    next_task: 'Siguiente tarea',
    cancel: 'Cancelar',
    back: 'Atrás',
    next: 'Continuar',
    save: 'Guardar',
    exit: 'Salir de la configuración',
    retry: 'Reintentar',
  },
  errors: {
    progress_load_failed: 'No se pudo cargar el progreso de configuración de este restaurante.',
    linked_company_unavailable:
      'Este enlace corresponde a un restaurante que no puedes abrir, así que estás en el actual.',
  },
  placeholder: {
    title: 'Este paso estará disponible próximamente',
    description: 'El asistente y el seguimiento del progreso están listos. Esta fase se desarrollará a continuación.',
  },
  new_restaurant: {
    title: 'Nuevo restaurante',
    menu: {
      title: 'Menú',
      description: 'Una demo omite la incorporación, así que importa su menú ahora.',
    },
    demo: {
      title: 'Nueva demo',
      description: 'Un restaurante de demostración para pruebas — omite la mayor parte de la incorporación.',
      label: 'Crear demo',
    },
    description: 'Dinos dónde está este restaurante. Lo buscaremos en Google Maps.',
  },
  location: {
    edit_description: 'Actualiza la ubicación de este restaurante.',
    cta: 'Crear restaurante',
    section: {
      address: 'Información básica',
      group: 'Marca',
      group_description: '¿Este local pertenece a una marca que ya tienes?',
    },
    form: {
      name: {
        label: 'Nombre del restaurante',
        placeholder: 'Busca tu restaurante…',
        help: 'Empieza a escribir para buscar este restaurante en Google Maps.',
      },
      address: {
        label: 'Dirección',
        placeholder: 'Calle y número',
      },
      city: {
        label: 'Ciudad',
      },
      zip_code: {
        label: 'Código postal',
      },
      country: {
        label: 'País',
      },
      region: {
        label: 'Estado / Región',
        placeholder: 'Selecciona un estado o región',
      },
    },
    group: {
      aria_label: 'Opciones de marca',
      deferred_hint: 'Elegirás el nombre de la marca y la dirección web en el último paso.',
      existing: {
        title: 'Añadir a una marca existente',
        description: 'Otro local bajo una marca que ya gestionas.',
        select_label: 'Marca',
        select_placeholder: 'Selecciona una marca',
      },
      new: {
        title: 'Crear una marca nueva',
        description: 'Un solo restaurante, o el primer local de una marca nueva.',
      },
    },
    toasts: {
      update_failed: 'No se pudo guardar la ubicación. Inténtalo de nuevo.',
      created: 'Restaurante creado',
      create_failed: 'No se pudo crear el restaurante. Inténtalo de nuevo.',
    },
  },
  domain: {
    url_setup: {
      title: 'Dirección de pedidos online',
      description: 'Dónde harán los pedidos los clientes.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'tu dominio de pedidos online',
        title: 'Usar nuestro dominio genérico',
      },
      custom: {
        title: 'Conectar tu propio dominio',
        description: 'Usa un dominio que el restaurante ya tiene.',
      },
    },
    toasts: {
      save_failed: 'No se pudo guardar la dirección de pedidos online. Inténtalo de nuevo.',
    },
  },
  go_live: {
    subtitle: 'Comprueba que cada paso esté completado y activa los pedidos en vivo.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Solo letras, números y guiones. Puedes cambiarlo más tarde, pero la dirección antigua dejará de funcionar.',
      title: 'Dirección de pedidos online',
      description: 'Aquí es donde tus clientes harán sus pedidos. Puedes cambiarlo más tarde.',
      label: 'Personalízala con el nombre del restaurante',
      placeholder: 'bella-italia',
      preview: 'Tu página de pedidos:',
      save: 'Guardar URL',
      saved: 'Dirección de pedidos online guardada',
      save_failed: 'No se pudo guardar la URL. Inténtalo de nuevo.',
      status: {
        checking: 'Comprobando disponibilidad…',
        available: 'Disponible',
        taken: 'Esta URL ya está en uso',
        invalid: 'Usa solo letras, números, guiones y guiones bajos',
        error: 'No se pudo comprobar la disponibilidad — inténtalo de nuevo',
      },
    },
    domain: {
      title: 'Dominio personalizado (opcional)',
      description: 'Usa tu propio dominio en lugar de la dirección proporcionada por FoodAmigos.',
      add: '+ Añadir un dominio personalizado',
      hide: 'Ocultar dominio personalizado',
      label: 'Tu dominio',
      placeholder: 'tienda.mirestaurante.com',
      save: 'Guardar',
      show_records: 'Ver registros DNS',
      hint: 'Solo para pedidos — tu sitio web necesita otro dominio. Por ejemplo, order.mirestaurante.com para la tienda y mirestaurante.com para el sitio web.',
      records_after_save:
        'En cuanto guardes el dominio, te mostramos los registros exactos que debes añadir en tu proveedor de DNS — un dominio principal (mirestaurante.com) y un subdominio (order.mirestaurante.com) necesitan registros distintos.',
      saved: 'Dominio personalizado guardado',
      save_failed: 'No se pudo guardar el dominio. Inténtalo de nuevo.',
      unconfirmed: {
        title: 'Ir en vivo no espera a este dominio',
        description:
          'Hasta que se confirmen sus registros, la página de pedidos sigue en su dirección estándar, y el restaurante puede ir en vivo ahí. En cuanto se confirmen —puede tardar hasta 48 horas—, el dominio mostrará la página de pedidos automáticamente.',
      },
    },
    locations: {
      title: 'Confirmar ubicaciones',
      description: 'Cada local de tu marca tiene su propia dirección de pedidos. Confírmalas o edítalas abajo.',
      save: 'Guardar ubicaciones',
      saved: 'URLs de ubicaciones guardadas',
      save_failed: 'No se pudo guardar una o más URLs de ubicaciones. Inténtalo de nuevo.',
    },
    preflight: {
      title: 'Antes de ir en vivo',
      description: 'Completa estos pasos para habilitar los pedidos en vivo.',
      url_setup: 'Dirección de pedidos configurada',
      online_payment: {
        your_provider: 'tu proveedor',
        payments_live: '{{title}} · hecho',
        online_payments_off: '{{title}} · no acepta pagos en línea',
        waiting_for_provider: '{{title}} · esperando a {{provider}}',
        hosted_not_finished: '{{title}} · finalizar con {{provider}}',
        action_needed: '{{title}} · acción necesaria',
        waiting_for_partner: '{{title}} · esperando a tu socio',
        not_set_up: '{{title}} · no configurado',
        business_details_missing: '{{title}} · añade los datos del negocio para los pagos',
      },
    },
    failed_checks: {
      title: 'Algunas cosas aún necesitan atención',
      items: {
        name: 'Nombre del restaurante',
        logo_url: 'Logotipo',
        pictures: 'Fotos de galería',
        menu_uploaded: 'Menú',
        opening_hours: 'Horario de apertura',
        address: 'Dirección',
        storefront: 'Dirección de pedidos',
        payments_configured: 'Pagos',
        stripe_billing: 'Facturación',
        test_orders: 'Pedido de prueba',
        google_business: 'Perfil de Google Business',
        master_promo_code: 'Código promocional de bienvenida',
        flyers_ordered: 'Folletos pedidos',
        identity: 'Tipo de restaurante y cocinas',
        billing_payment_method: 'Método de pago',
        billing_license: 'Licencia',
        business_name: 'Nombre de la empresa / del restaurante',
        payment_method: 'Efectivo o pagos en línea',
        stripe_processing_fee: 'Comisión de procesamiento del partner',
      },
      force: 'Ir en vivo de todos modos',
      blocker: '(obligatorio)',
      link: 'Abrir facturación de socios',
    },
    error: 'No se pudo habilitar los pedidos en vivo. Inténtalo de nuevo.',
    gate_hint: 'Completa la lista de verificación para habilitar Ir en vivo.',
    business_name: {
      label: 'Nombre de la empresa / del restaurante',
      help: 'Aparece en tus condiciones de uso y tu política de privacidad. Usa el nombre con el que opera tu negocio.',
      save: 'Guardar',
      save_failed: 'No se pudo guardar el nombre de la empresa. Inténtalo de nuevo.',
      hint: 'Guarda primero el nombre de la empresa / del restaurante.',
    },
    cash_only: {
      message:
        'Los pagos online están desactivados: los clientes solo pueden pagar en efectivo al recoger o en la entrega hasta que se conecte y verifique una pasarela.',
    },
    payment_blocked: {
      title: 'Activa los pagos en efectivo o configura los pagos en línea para activarte.',
      payment_method: 'Los clientes necesitan una forma de pagar.',
      turn_on_cash: 'Activar pagos en efectivo',
      ask_partner: 'Pide a tu socio que active los pagos en efectivo, o',
      set_up_online: 'configura los pagos en línea',
    },
    buttons: {
      go_live: 'Ir en vivo 🚀',
      finish: 'Finalizar configuración',
    },
    celebration: {
      title: '¡Estás en vivo!',
      title_named: '¡{{name}} ya está en línea!',
      subtitle: 'Tu restaurante ya acepta pedidos en vivo.',
      license: '{{plan}} · activo',
      license_trial: '{{plan}} · gratis hasta el {{date}}',
      finish: 'Finalizar configuración',
    },
    service_fee: {
      title: 'Tarifa de servicio',
      headline: 'Gana ingresos extra sin cobrar a tus restaurantes',
      subtitle:
        'Añade una pequeña tarifa de servicio que los clientes pagan al finalizar el pedido. Tú te quedas con la mitad. Permanece desactivada hasta que la actives.',
      subtitle_share:
        'Añade una pequeña tarifa de servicio que los clientes pagan al finalizar el pedido. Tú te quedas con el {{share}}%. Permanece desactivada hasta que la actives.',
      tiles: {
        guest: {
          title: 'Lo paga el cliente',
          description: 'Se muestra al pagar, como en las apps de reparto.',
        },
        share: {
          title: 'La mitad es para ti',
          title_share: 'El {{share}}% es para ti',
          description: 'Reparto {{share}}/{{rest}} con FoodAmigos.',
        },
        choice: {
          title: 'Tú decides',
          description: 'Desactivada por defecto. Cámbiala cuando quieras.',
        },
      },
      preview: {
        title: 'Lo que verían los clientes al pagar',
        subtotal: 'Subtotal del pedido',
        fee: 'Tarifa de servicio',
        fee_terms: '({{percentage}}%, máx. {{max}})',
        guest_pays: 'El cliente paga',
        split_partner: '<strong>Tú {{amount}}</strong> por pedido',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'El importe del pedido del restaurante no cambia.',
      },
      earnings: {
        title: 'Lo que podrías ganar con este restaurante',
        orders: 'Pedidos online al mes',
        average_order: 'Pedido medio',
        per_month: 'al mes para ti',
        collected: '{{amount}} recaudados de los clientes al mes. Tu parte: {{share}}%. Solo una estimación.',
        effective_rate: 'Tarifa efectiva en todos los pedidos: {{rate}}',
      },
      choice: {
        question: '¿Añadir una tarifa de servicio para este restaurante?',
        enabled: {
          title: 'Añadir tarifa de servicio',
          recommended: 'Recomendado: {{percentage}}%, máx. {{max}}',
          description: 'Los clientes pagan una pequeña tarifa. Tú ganas una parte.',
        },
        skipped: {
          title: 'Sin tarifa de servicio',
          description: 'Los clientes pagan solo los precios del menú.',
        },
      },
      footer: {
        enabled:
          'Los clientes pagan el {{percentage}}%, máx. {{max}} por pedido. Cámbiala cuando quieras en <settings>Ajustes de pedidos → Tarifa de servicio</settings>.',
        skipped:
          'Sin tarifa de servicio por ahora. Cámbiala cuando quieras en <settings>Ajustes de pedidos → Tarifa de servicio</settings>.',
      },
      enabled:
        'La tarifa de servicio ya está activa en este restaurante al {{percentage}} %, con un máximo de {{max}} por pedido. Se aplica a todos los pedidos nuevos a partir de ahora. Puedes cambiarla cuando quieras en <settings>Ajustes de pedidos → Tarifa de servicio</settings>.',
      enabled_partner_default:
        'La tarifa de servicio ya está activa en este restaurante. Se aplica tu valor predeterminado de socio: {{percentage}} %, con un máximo de {{max}} por pedido. Se aplica a todos los pedidos nuevos a partir de ahora. Puedes cambiarla cuando quieras en <settings>Ajustes de pedidos → Tarifa de servicio</settings>.',
      buttons: {
        enable: 'Activar tarifa de servicio',
        continue_without: 'Continuar sin tarifa',
      },
      skipped:
        'Los clientes de este restaurante no pagan tarifa de servicio. Puedes activarla cuando quieras en <settings>Ajustes de pedidos → Tarifa de servicio</settings>.',
      toasts: {
        save_failed: 'No se pudo guardar la elección de tarifa de servicio. Inténtalo de nuevo.',
      },
    },
  },
  toasts: {
    save_failed: 'No se pudieron guardar los cambios. Inténtalo de nuevo.',
    saved: 'Guardado',
  },
  optional: 'Opcional',
  identity: {
    min_cuisine_hint: 'Selecciona al menos una cocina para continuar.',
    sections: {
      restaurant_type: {
        title: 'Tipo de restaurante',
        description: '¿Qué tipo de establecimiento es este?',
      },
      cuisine: {
        title: 'Tipos de cocina',
        description: 'Elige al menos uno.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Recomendado',
      import: {
        title: 'Importar desde una plataforma',
        description: 'Importa el menú desde GloriaFood, Wolt, Lieferando, Deliveroo y más.',
      },
      manual: {
        title: 'Crea tu menú desde cero',
        description: 'Crea categorías y elementos manualmente en el editor de menús.',
      },
    },
    import: {
      title: 'Importar desde plataforma existente',
      in_progress: {
        title: 'Importando tu menú…',
        description: 'Esto suele tardar menos de dos minutos. Completaremos este paso en cuanto finalice.',
      },
      failed: {
        title: 'La importación no terminó',
        description: 'No se pudo completar la importación del menú. Comprueba los detalles e inténtalo de nuevo.',
      },
      blocked: {
        until: 'En pausa hasta {{time}}',
        release: 'Liberar el enlace',
        released: 'Enlace liberado. Puedes iniciar la importación de nuevo.',
        release_failed: 'No se pudo liberar el enlace. Inténtalo de nuevo en unos instantes.',
      },
      stalled: {
        title: 'Aún importando…',
        description:
          'La importación está tardando más de lo habitual. Puede que siga ejecutándose en segundo plano; compruébalo de nuevo en un momento. Iniciar una nueva importación ahora podría duplicar el menú.',
      },
    },
    manual: {
      title: 'Crea tu menú desde cero',
      description:
        'El editor de menús se abre con un menú vacío. Este paso se completa cuando exista al menos una categoría y un elemento.',
      open_editor: 'Abrir editor de menús',
      waiting: {
        title: 'Esperando tu primer elemento de menú',
        description: 'Una vez que añadas un elemento en el editor de menús, este paso podrá completarse.',
      },
      found: {
        title: 'Elementos de menú detectados',
        description: 'Genial: puedes continuar al siguiente paso.',
      },
    },
    complete: {
      title: 'Menú listo',
      description: 'Tu menú está en su lugar. Puedes revisarlo en cualquier momento desde el editor de menús.',
    },
    buttons: {
      start_import: 'Iniciar importación',
      importing: 'Importando…',
      retry: 'Reintentar importación',
      check_again: 'Comprobar de nuevo',
      continue: 'Continuar',
      skip: 'Omitir por ahora',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'este restaurante',
    location: {
      title: 'Ubicación',
      description: '¿Dónde está el restaurante y a qué marca pertenece?',
    },
    identity: {
      title: 'Identidad',
      description: 'Tipo de restaurante y cocinas.',
    },
    brand: {
      title: 'Marca',
      description: 'Logotipo, colores y galería.',
    },
    operations: {
      title: 'Datos del local',
      description:
        'Configura cómo {{name}} recibe pedidos. Es el mínimo necesario antes de poder recibir cualquier pedido.',
    },
    menu: {
      title: 'Menú',
      description:
        'Sube el menú de {{name}} a la plataforma. Impórtalo desde una plataforma existente en menos de dos minutos o créalo desde cero.',
    },
    domain: {
      title: 'Dominio',
      description: 'La dirección web que usan los clientes para pedir en este restaurante.',
    },
    go_live: {
      title: 'Ir en vivo',
      description: 'Habilitar pedidos en vivo.',
    },
    payouts: {
      title: 'Pago online',
      description: 'Cómo cobra este restaurante los pagos online.',
    },
    service_fee: {
      title: 'Tarifa de servicio',
      description:
        'Si los clientes pagan una tarifa de servicio al finalizar el pedido. Puedes cambiarlo más tarde en Ajustes de pedidos → Tarifas.',
    },
    bank_account: {
      title: 'Cuenta bancaria',
      description:
        'Adónde van los pagos. No es necesaria para salir en vivo: los cobros esperan en el saldo hasta que se añada una cuenta.',
    },
  },
  business_details: {
    locked: 'Estos datos están verificados con tu proveedor de pagos. Para cambiarlos, contacta con FoodAmigos.',
    section: {
      title: 'Datos de la empresa',
    },
    fields: {
      business_type: {
        label: 'Tipo de negocio',
        options: {
          company: 'Empresa (GmbH, UG, Ltd, Inc — una entidad legal registrada)',
          individual: 'Autónomo (tú posees y diriges el negocio personalmente)',
        },
      },
      owner_first_name: { label: 'Nombre del propietario' },
      owner_last_name: { label: 'Apellido del propietario' },
      legal_name: {
        label: 'Razón social',
        individual: 'Diriges el negocio personalmente, así que el nombre del propietario se usa como razón social.',
      },
      legal_address: { label: 'Domicilio social' },
      legal_city: { label: 'Ciudad' },
      legal_state: { label: 'Estado o provincia' },
      legal_zip_code: { label: 'Código postal' },
      legal_country: { label: 'País' },
      tax_id: {
        generic: 'Número fiscal o de registro',
        personal: 'Solo se muestran los últimos cuatro dígitos. Déjalo tal cual para mantener el número sin cambios.',
        hint: 'Por ejemplo, {{example}}.',
        invalid: 'Esto no coincide con el formato habitual para este país y tipo de negocio, por ejemplo, {{example}}.',
      },
      is_vat_registered: { label: 'Este negocio está registrado a efectos de IVA' },
      vat_id: {
        label: 'Número de IVA',
        help: 'Empieza por {{country}}, seguido de 8 a 12 letras o dígitos.',
        invalid: 'El número de IVA debe empezar por {{country}}, seguido de 8 a 12 letras o dígitos.',
        help_unprefixed: 'Su número de IVA o de identificación fiscal, tal como se le asignó.',
        invalid_unprefixed: 'No parece un número de IVA: use entre 5 y 25 letras o dígitos.',
      },
    },
    toasts: {
      save_failed: 'No se pudieron guardar los datos de la empresa. Inténtalo de nuevo.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Nombre corto',
        placeholder: 'p. ej. Amigo Pizza',
        tooltip: 'Un nombre de visualización más corto usado en la tienda y los recibos.',
      },
      primary_color: {
        label: 'Color principal',
        invalid: 'Introduce un color hex válido, p. ej. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nombre',
      short_name_hint: 'Usado en la tienda, recibos y notificaciones.',
      logo_and_colour: 'Logotipo y color de marca principal',
      logo: 'Subir logotipo',
      logo_hint: 'Si dejas esto vacío, se usará el logo de tu marca.',
      gallery: 'Fotos de galería',
      gallery_hint: 'Añade hasta {{max}} fotos de tu restaurante. Arrastra para reordenar.',
      gallery_count: '{{count}} de {{max}} añadidas',
    },
    toasts: {
      image_uploaded: 'Imagen subida',
      image_upload_failed: 'No se pudo subir la imagen. {{error}}',
      save_failed: 'No se pudieron guardar los datos de marca. Inténtelo de nuevo.',
    },
  },
  operations: {
    contact: {
      title: 'Contacto',
      description: 'Usado para notificaciones de pedidos y comunicaciones con clientes.',
      phone: {
        label: 'Teléfono del restaurante',
        placeholder: '+49 30 1234567',
        invalid: 'Introduce un número de teléfono internacional completo, p. ej. +49 30 1234567',
      },
      email: { label: 'Email del restaurante', placeholder: 'pedidos@restaurante.com' },
    },
    methods: {
      title: 'Métodos de pedido',
      description: 'Cómo pueden pedir los clientes y el tiempo estimado de cada método.',
      pickup: {
        label: 'Recogida',
        prep_time: { label: 'Tiempo medio de preparación (min)' },
      },
      delivery: {
        label: 'Entrega a domicilio',
        delivery_time: { label: 'Tiempo medio de entrega (min)' },
        advanced_zones: 'Configuración avanzada de zonas',
      },
    },
    timing: {
      title: 'Horario de pedidos',
      description: 'Cuándo pueden hacer pedidos los clientes: ahora, más tarde o con antelación.',
      at_least_one: 'Activa pedidos inmediatos o programados (se requiere al menos uno).',
      asap: { label: 'Aceptar pedidos inmediatos' },
      scheduled: { label: 'Aceptar pedidos programados' },
      reminders: { label: 'Enviar un recordatorio automático antes de que venza un pedido programado' },
      pre_order: {
        label: 'Permitir pedidos anticipados para días futuros',
        days: { label: 'Cuántos días de antelación (0-31)' },
      },
    },
    tax: {
      title: 'IVA',
      description:
        'La tasa aplicada a los productos de este restaurante. Comienza con la tasa de la región — cámbiala solo si este restaurante cobra algo distinto.',
      rate: { label: 'Tasa de IVA', placeholder: 'p. ej. 7' },
      dedicated: { label: 'El IVA varía según el producto' },
    },
    hours: {
      title: 'Horario de apertura',
      description: 'Los días y horas en que este restaurante acepta pedidos.',
      same_every_day: 'El mismo horario todos los días',
      split_shifts: {
        title: 'Este restaurante tiene horarios de apertura divididos',
        description:
          'Algunos días tienen más de un período de apertura (por ejemplo, turno de comida y cena). El editor simple muestra un período por día, por lo que mantenemos tu horario actual — edita los turnos divididos en Configuración de pedidos → Horario de apertura.',
      },
    },
    toasts: {
      save_failed: 'No se pudieron guardar los ajustes operativos. Inténtelo de nuevo.',
    },
  },
  online_payment: {
    question: '¿Quieres aceptar pagos en línea para este restaurante?',
    yes: 'Sí',
    not_now: 'Ahora no',
    declined:
      'Los clientes pagarán al recoger o al recibir el pedido. Puedes activar los pagos en línea en cualquier momento desde Configuración.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Los pagos aún no están configurados para tu cuenta de partner',
        description:
          'Un administrador de tu cuenta de partner debe elegir quién procesa los pagos antes de que este restaurante pueda aceptar pagos en línea. Mientras tanto, puedes continuar con los demás pasos.',
      },
    },
    continue_to_go_live: 'Continuar a Puesta en marcha',
    platform_line: 'Los pagos de este restaurante se procesan a través de FoodAmigos payments.',
    only_connection: 'Los pagos se procesan a través de {{name}} (tu único proveedor conectado).',
    partner_issue: {
      title: 'Tu socio {{partner}} debe terminar de configurar su proveedor de pagos',
      description:
        'Su proveedor de pagos aún no puede dar de alta restaurantes. Se lo hemos comunicado; tus datos están guardados, así que vuelve cuando confirme que está listo.',
      retry_hint: 'Una vez solucionado, vuelve a continuar con el proveedor y lo reintentaremos.',
      open_settings: 'Abrir la configuración de tu pasarela de pago',
    },
    connect_another: 'Conectar otro proveedor',
    checking: 'Comprobando con {{provider}}…',
    checking_generic: 'Verificando con el proveedor de pagos…',
    retry: 'Reintentar',
    not_set_up: {
      title: 'Aún no hay un proveedor de pagos vinculado',
      description:
        'Tu socio vincula un proveedor de pagos a este restaurante. Una vez lo haga, podrás terminar la configuración aquí.',
    },
    choice: {
      title: '¿Cuál de tus proveedores conectados debe usar este restaurante?',
      primary: 'Principal',
      confirm: 'Usar este proveedor',
      cancel: 'Cancelar',
    },
    using: 'Usando {{name}}',
    change: 'Cambiar',
    payout_details: {
      title: 'Datos del negocio para los pagos',
      description: 'El proveedor de pagos los necesita para verificar tu negocio y enviarte los pagos.',
      business_type: {
        company: {
          title: 'Empresa',
          description: 'GmbH, SL, Ltd, Inc: una entidad jurídica registrada',
        },
        individual: {
          title: 'Individual',
          description: 'Eres el propietario del negocio y lo gestionas personalmente',
        },
      },
      registered_address: 'Domicilio social',
      legal_address: 'Dirección',
      legal_state: 'Estado / región',
      vat_id: 'NIF-IVA',
      optional: '(opcional)',
      fill_first: 'Rellena primero los datos del negocio para los pagos de arriba.',
    },
    hand_off: {
      title: 'Siguiente: completa la configuración con {{provider}}',
      description:
        '{{provider}} pedirá el documento de identidad del titular en su propio formulario, usando los datos de la empresa para pagos indicados arriba. Unos 10 minutos. La cuenta bancaria viene después de la puesta en marcha.',
      cta: 'Continuar a {{provider}}',
      transition: 'Llevándote a {{provider}}…',
      error: 'No pudimos abrir el formulario de {{provider}}. Inténtalo de nuevo.',
    },
    states: {
      verified: 'Los pagos están activos.',
      submitted: {
        title: 'Datos enviados a {{provider}}',
        description:
          'La verificación suele tardar de 1 a 2 días hábiles. Enviaremos un correo al propietario del restaurante cuando esté lista.',
        description_email:
          'La verificación suele tardar de 1 a 2 días hábiles. Te enviaremos un correo a {{email}} cuando esté lista.',
        review: {
          business_type: 'Tipo de negocio',
          legal_name: 'Nombre legal',
          address: 'Domicilio social',
          types: {
            company: 'Empresa',
            individual: 'Individual',
          },
        },
      },
      incomplete: {
        title: 'No has terminado con {{provider}}',
        description: 'Tus datos están guardados — el enlace es válido por 2 días.',
        expired: 'Tus datos están guardados, pero el enlace ha expirado.',
        cta: 'Continuar con {{provider}}',
        new_link: 'Obtener un nuevo enlace y continuar',
        check_details: 'Revisar mis datos primero',
      },
      action_needed: {
        title: '{{provider}} necesita un dato más',
        description:
          '{{provider}} no pudo verificar uno de los datos proporcionados. Abre su formulario de nuevo para corregirlo.',
        cta: 'Abrir de nuevo el formulario de {{provider}}',
      },
    },
    connected: {
      title: 'Los pagos se procesan a través de {{name}}',
      description: 'Este restaurante está vinculado a la cuenta {{name}} — no hay nada más que configurar aquí.',
      failed: 'Aún no pudimos vincular este restaurante a {{name}}',
    },
    errors: {
      generic: 'Algo salió mal. Inténtalo de nuevo.',
      load_failed: 'No pudimos cargar la configuración de pagos de este restaurante.',
    },
  },
  bank_account: {
    section: {
      title: 'Cuenta bancaria para pagos',
      description: 'Los pagos se envían en {{currency}}, la moneda en la que este restaurante recibe los cobros.',
    },
    done: 'Volver al panel',
    load_failed: 'No pudimos cargar la cuenta bancaria de este restaurante.',
    retry: 'Reintentar',
    no_permission: 'Solo el propietario del restaurante o el socio puede introducir la cuenta bancaria.',
    confirm_with_provider: 'Confirmar con Adyen',
    toasts: {
      save_failed: 'No pudimos guardar la cuenta bancaria. Revisa los datos.',
    },
  },
  payouts: {
    finish_setup: 'Finalizar configuración',
  },
};
